import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './passport-mobile.css';
import { loadPassportConfig } from './loadPassportConfig';
import { initPassportMobileShell } from './utils/passportMobileInit';

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', fontFamily: 'system-ui', maxWidth: '36rem' }}>
          <h1 style={{ margin: '0 0 0.5rem' }}>Carrier Passport</h1>
          <p style={{ margin: 0, color: '#6b7280' }}>
            Something went wrong loading the app. Open the browser console (F12) for details.
          </p>
          <p style={{ margin: '1rem 0 0', fontSize: '0.875rem' }}>
            If you just set up the app, copy <code>passport/.env.example</code> to{' '}
            <code>passport/.env</code>, set VITE_FIREBASE_* and VITE_API_URL, then run <code>npm run generate-env</code> and <code>npm run dev</code>.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

void (async () => {
  try {
    await loadPassportConfig();
  } catch (e) {
    const msg = e instanceof Error ? e.message : String(e);
    root.innerHTML = `
      <div style="padding:2rem;font-family:system-ui,sans-serif;max-width:36rem">
        <h1 style="margin:0 0 0.5rem">Carrier Passport</h1>
        <p style="margin:0;color:#b45309">Could not load app configuration.</p>
        <pre style="margin-top:1rem;white-space:pre-wrap;font-size:0.8rem;background:#f3f4f6;padding:1rem;border-radius:0.5rem">${msg.replace(/</g, '&lt;')}</pre>
      </div>`;
    return;
  }

  await initPassportMobileShell();

  const appTree = (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
  // StrictMode double-mounts effects in dev and breaks some third-party widgets (e.g. Turnstile). Keep it in production builds only.
  ReactDOM.createRoot(root).render(import.meta.env.PROD ? <React.StrictMode>{appTree}</React.StrictMode> : appTree);
})();
